import { render, staticRenderFns } from "./ChartQrtPorTipologia.vue?vue&type=template&id=7cfb5076&"
import script from "./ChartQrtPorTipologia.vue?vue&type=script&lang=js&"
export * from "./ChartQrtPorTipologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports